import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {
  required,
  email,
  length,
  min,
  min_value,
  max,
  max_value,
  size,
  confirmed,
  ext,
  numeric,
  alpha,
  alpha_dash,
  alpha_spaces,
  digits,
  regex,
  alpha_num,
  is_not,
} from "vee-validate/dist/rules";
import { localize } from "vee-validate";
import es from "vee-validate/dist/locale/es.json";
import en from "vee-validate/dist/locale/en.json";

const parseCustomDate = (dateString) => {
  const [datePart, timePart, period] = dateString.split(' ');
  const [day, month, year] = datePart.split('/');
  const [hours, minutes] = timePart.split(':');
  
  let hour24 = parseInt(hours);
  if ((period.toLowerCase() === 'pm' || period.toLowerCase() === 'p.m.') && hour24 !== 12) {
      hour24 += 12;
  } else if ((period.toLowerCase() === 'am' || period.toLowerCase() === 'a.m.') && hour24 === 12) {
      hour24 = 0;
  }
  
  return new Date(year, month - 1, day, hour24, minutes);
}

// Add rules
extend("required", required);
extend("email", email);
extend("length", length);
extend("min_value", min_value);
extend("min", min);
extend("max_value", max_value);
extend("max", max);
extend("ext", ext);
extend("size", size);
extend("numeric", numeric);
extend("confirmed", confirmed);
extend("alpha", alpha);
extend("alpha_spaces", alpha_spaces);
extend("digits", digits);
extend("regex", regex);
extend("alpha_dash", alpha_dash);
extend("alpha_num", alpha_num);
extend("is_not", is_not);
extend("not_empty", {
  params: ["message"],
  validate(value, { message }) {
    if (!(value.length >= 0))
      return message ?? `Debe tener al menos una amenidad`;

    return true;
  }
});
extend("exact_length", {
  params: ["length", "message"],
  validate(val, { length, message }) {
    if (val.length !== Number(length))
      return message ?? "Must have " + length + " items";

    return true;
  }
});
extend("after_than", {
  params: ['target'],
  validate: (value, { target }) => {
    if (!value || !target) {
      return false
    }
    const valueDate = parseCustomDate(value)
    const targetDate = parseCustomDate(target)
    return valueDate.getTime() > targetDate.getTime()
  },
  message: "La fecha y hora de este campo debe ser posterior a la fecha y hora de {target}"
});
extend("before_than", {
  params: ['target'],
  validate: (value, { target }) => {
    return (new Date(value)).getTime() < (new Date(target)).getTime()
  },
  message: "Este campo debe ser antes de {target}"
})
extend("greater_than", {
  params: ['target'],
  validate: (value, { target }) => {
    const n1 =  typeof value === "string" ? parseFloat(value) : value
    const n2 =  typeof target === "string" ? parseFloat(target) : target
    return n1 > n2
  },
  message: "Este campo debe ser mayor a {target}"
})
extend("less_than", {
  params: ['target'],
  validate: (value, { target }) => {
    const n1 =  typeof value === "string" ? parseFloat(value) : value
    const n2 =  typeof target === "string" ? parseFloat(target) : target
    return n1 < n2
  },
  message: "Este campo debe ser menor a {target}"
})

localize("es", es);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
